import { createLucideIcon } from "lucide-react";

export const JsonFile = createLucideIcon(
    "JsonFile",
    [
        [
            "path",
            {
                d: "M10.6594 8H10.6654",
                key: "17mq1y",
            },
        ],
        [
            "path",
            {
                d: "M12 14C12.8214 14 13.4874 13.2325 13.4874 12.2857C13.4874 10.7872 13.4208 9.79097 14.4488 8.60609C14.7393 8.27136 14.7393 7.72864 14.4488 7.39391C13.4208 6.20903 13.4874 5.21278 13.4874 3.71429C13.4874 2.76751 12.8214 2 12 2",
                key: "17lvr8",
            },
        ],
        [
            "path",
            {
                d: "M4 14C3.17856 14 2.51265 13.2325 2.51265 12.2857C2.51265 10.7872 2.57918 9.79097 1.55115 8.60609C1.26073 8.27136 1.26073 7.72864 1.55115 7.39391C2.55664 6.23501 2.51265 5.22662 2.51265 3.71429C2.51265 2.76751 3.17856 2 4 2",
                key: "1i8ucc",
            },
        ],
        [
            "path",
            {
                d: "M5.332 8H5.338",
                key: "m3nr0t",
            },
        ],
        [
            "path",
            {
                d: "M7.9957 8H8.0017",
                key: "b6dvws",
            },
        ],
    ],
);
